// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/subscription.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "./error_pb.js";
import { AutoPay } from "./auto_pay_pb.js";
import { CreditLineAccount } from "./credit_line_pb.js";

/**
 * @generated from enum web.public.SubscriptionPlan
 */
export enum SubscriptionPlan {
  /**
   * @generated from enum value: BASIC = 0;
   */
  BASIC = 0,

  /**
   * @generated from enum value: PREMIUM = 1;
   */
  PREMIUM = 1,

  /**
   * @generated from enum value: CASH_ADVANCE_ADVANCE = 2;
   */
  CASH_ADVANCE_ADVANCE = 2,

  /**
   * @generated from enum value: CASH_ADVANCE_PREMIUM = 3;
   */
  CASH_ADVANCE_PREMIUM = 3,

  /**
   * @generated from enum value: ULTIMATE = 4;
   */
  ULTIMATE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionPlan)
proto3.util.setEnumType(SubscriptionPlan, "web.public.SubscriptionPlan", [
  { no: 0, name: "BASIC" },
  { no: 1, name: "PREMIUM" },
  { no: 2, name: "CASH_ADVANCE_ADVANCE" },
  { no: 3, name: "CASH_ADVANCE_PREMIUM" },
  { no: 4, name: "ULTIMATE" },
]);

/**
 * @generated from message web.public.OpenSubscriptionRequest
 */
export class OpenSubscriptionRequest extends Message<OpenSubscriptionRequest> {
  /**
   * deprecated: use subscription_plan_title
   *
   * @generated from field: int32 subscription_plan_id = 1;
   */
  subscriptionPlanId = 0;

  /**
   * deprecated: use autorenew_on
   *
   * @generated from field: web.public.AutoRenew auto_renew = 2;
   */
  autoRenew?: AutoRenew;

  /**
   * @generated from field: string payment_method_token = 3;
   */
  paymentMethodToken = "";

  /**
   * @generated from field: web.public.SubscriptionPlan subscription_plan_title = 4;
   */
  subscriptionPlanTitle = SubscriptionPlan.BASIC;

  /**
   * @generated from field: bool autorenew_on = 5;
   */
  autorenewOn = false;

  constructor(data?: PartialMessage<OpenSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OpenSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_plan_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "auto_renew", kind: "message", T: AutoRenew },
    { no: 3, name: "payment_method_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "subscription_plan_title", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 5, name: "autorenew_on", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionRequest | PlainMessage<OpenSubscriptionRequest> | undefined, b: OpenSubscriptionRequest | PlainMessage<OpenSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.OpenSubscriptionResponse
 */
export class OpenSubscriptionResponse extends Message<OpenSubscriptionResponse> {
  /**
   * @generated from field: web.public.OpenSubscriptionResponse.Status status = 1;
   */
  status = OpenSubscriptionResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<OpenSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OpenSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(OpenSubscriptionResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionResponse | PlainMessage<OpenSubscriptionResponse> | undefined, b: OpenSubscriptionResponse | PlainMessage<OpenSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionResponse, a, b);
  }

  static _enums: {
    Status: typeof OpenSubscriptionResponse.Status,
  };
}

export namespace OpenSubscriptionResponse {
  /**
   * @generated from enum web.public.OpenSubscriptionResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OpenSubscriptionResponse.Status)
  proto3.util.setEnumType(OpenSubscriptionResponse.Status, "web.public.OpenSubscriptionResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.UpdateAutoRenewalStatusRequest
 */
export class UpdateAutoRenewalStatusRequest extends Message<UpdateAutoRenewalStatusRequest> {
  /**
   * @generated from field: web.public.UserSubscription user_subscription = 1;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<UpdateAutoRenewalStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateAutoRenewalStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAutoRenewalStatusRequest {
    return new UpdateAutoRenewalStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAutoRenewalStatusRequest {
    return new UpdateAutoRenewalStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAutoRenewalStatusRequest {
    return new UpdateAutoRenewalStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAutoRenewalStatusRequest | PlainMessage<UpdateAutoRenewalStatusRequest> | undefined, b: UpdateAutoRenewalStatusRequest | PlainMessage<UpdateAutoRenewalStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAutoRenewalStatusRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.OpenSubscriptionAndCreditLineRequest
 */
export class OpenSubscriptionAndCreditLineRequest extends Message<OpenSubscriptionAndCreditLineRequest> {
  /**
   * @generated from field: int32 subscription_plan_id = 1 [deprecated = true];
   * @deprecated
   */
  subscriptionPlanId = 0;

  /**
   * @generated from field: bool autorenew = 2;
   */
  autorenew = false;

  /**
   * derived from product_token
   *
   * @generated from field: web.public.SubscriptionPlan subscription_plan_title = 3 [deprecated = true];
   * @deprecated
   */
  subscriptionPlanTitle = SubscriptionPlan.BASIC;

  /**
   * @generated from field: web.public.AutoPay.Settings auto_pay = 4;
   */
  autoPay?: AutoPay.Settings;

  /**
   * @generated from field: string product_token = 5;
   */
  productToken = "";

  /**
   * @generated from field: google.protobuf.Timestamp first_payment_date = 6;
   */
  firstPaymentDate?: Timestamp;

  /**
   * @generated from field: bool pay_upfront = 7;
   */
  payUpfront = false;

  constructor(data?: PartialMessage<OpenSubscriptionAndCreditLineRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OpenSubscriptionAndCreditLineRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_plan_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "autorenew", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "subscription_plan_title", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 4, name: "auto_pay", kind: "message", T: AutoPay.Settings },
    { no: 5, name: "product_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "first_payment_date", kind: "message", T: Timestamp },
    { no: 7, name: "pay_upfront", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionAndCreditLineRequest {
    return new OpenSubscriptionAndCreditLineRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionAndCreditLineRequest {
    return new OpenSubscriptionAndCreditLineRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionAndCreditLineRequest {
    return new OpenSubscriptionAndCreditLineRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionAndCreditLineRequest | PlainMessage<OpenSubscriptionAndCreditLineRequest> | undefined, b: OpenSubscriptionAndCreditLineRequest | PlainMessage<OpenSubscriptionAndCreditLineRequest> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionAndCreditLineRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.RenewSubscriptionAndCreditLineRequest
 */
export class RenewSubscriptionAndCreditLineRequest extends Message<RenewSubscriptionAndCreditLineRequest> {
  /**
   * @generated from field: web.public.SubscriptionPlan subscription_plan_title = 1;
   */
  subscriptionPlanTitle = SubscriptionPlan.BASIC;

  /**
   * @generated from field: string product_token = 2;
   */
  productToken = "";

  constructor(data?: PartialMessage<RenewSubscriptionAndCreditLineRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RenewSubscriptionAndCreditLineRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription_plan_title", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 2, name: "product_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RenewSubscriptionAndCreditLineRequest {
    return new RenewSubscriptionAndCreditLineRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RenewSubscriptionAndCreditLineRequest {
    return new RenewSubscriptionAndCreditLineRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RenewSubscriptionAndCreditLineRequest {
    return new RenewSubscriptionAndCreditLineRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RenewSubscriptionAndCreditLineRequest | PlainMessage<RenewSubscriptionAndCreditLineRequest> | undefined, b: RenewSubscriptionAndCreditLineRequest | PlainMessage<RenewSubscriptionAndCreditLineRequest> | undefined): boolean {
    return proto3.util.equals(RenewSubscriptionAndCreditLineRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.AutoRenew
 */
export class AutoRenew extends Message<AutoRenew> {
  /**
   * @generated from field: web.public.AutoRenew.Status status = 1;
   */
  status = AutoRenew.Status.UNKNOWN;

  /**
   * @generated from field: string upsell = 2;
   */
  upsell = "";

  /**
   * @generated from field: google.protobuf.Timestamp renewal_at = 3;
   */
  renewalAt?: Timestamp;

  /**
   * @generated from field: int32 renewal_price_cents = 4;
   */
  renewalPriceCents = 0;

  constructor(data?: PartialMessage<AutoRenew>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.AutoRenew";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(AutoRenew.Status) },
    { no: 2, name: "upsell", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "renewal_at", kind: "message", T: Timestamp },
    { no: 4, name: "renewal_price_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AutoRenew {
    return new AutoRenew().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AutoRenew {
    return new AutoRenew().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AutoRenew {
    return new AutoRenew().fromJsonString(jsonString, options);
  }

  static equals(a: AutoRenew | PlainMessage<AutoRenew> | undefined, b: AutoRenew | PlainMessage<AutoRenew> | undefined): boolean {
    return proto3.util.equals(AutoRenew, a, b);
  }

  static _enums: {
    Status: typeof AutoRenew.Status,
  };
}

export namespace AutoRenew {
  /**
   * @generated from enum web.public.AutoRenew.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: ENABLED = 1;
     */
    ENABLED = 1,

    /**
     * @generated from enum value: DISABLED = 2;
     */
    DISABLED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(AutoRenew.Status)
  proto3.util.setEnumType(AutoRenew.Status, "web.public.AutoRenew.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ENABLED" },
    { no: 2, name: "DISABLED" },
  ]);
}

/**
 * @generated from message web.public.UserSubscription
 */
export class UserSubscription extends Message<UserSubscription> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: web.public.UserSubscription.Status status = 3;
   */
  status = UserSubscription.Status.UNKNOWN;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: web.public.AutoRenew auto_renew = 7;
   */
  autoRenew?: AutoRenew;

  /**
   * @generated from field: google.protobuf.Timestamp terminated_at = 8;
   */
  terminatedAt?: Timestamp;

  /**
   * deprecated
   *
   * @generated from field: repeated web.public.UserSubscription.Benefit benefits = 9;
   */
  benefits: UserSubscription.Benefit[] = [];

  /**
   * @generated from field: web.public.SubscriptionPlan plan = 10;
   */
  plan = SubscriptionPlan.BASIC;

  /**
   * @generated from field: google.protobuf.Timestamp opened_at = 11;
   */
  openedAt?: Timestamp;

  /**
   * @generated from field: web.public.SubscriptionPlanInfo plan_info = 12;
   */
  planInfo?: SubscriptionPlanInfo;

  /**
   * @generated from field: web.public.SubscriptionPlanInfo target_plan_info = 13;
   */
  targetPlanInfo?: SubscriptionPlanInfo;

  constructor(data?: PartialMessage<UserSubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UserSubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(UserSubscription.Status) },
    { no: 4, name: "expires_at", kind: "message", T: Timestamp },
    { no: 7, name: "auto_renew", kind: "message", T: AutoRenew },
    { no: 8, name: "terminated_at", kind: "message", T: Timestamp },
    { no: 9, name: "benefits", kind: "message", T: UserSubscription.Benefit, repeated: true },
    { no: 10, name: "plan", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 11, name: "opened_at", kind: "message", T: Timestamp },
    { no: 12, name: "plan_info", kind: "message", T: SubscriptionPlanInfo },
    { no: 13, name: "target_plan_info", kind: "message", T: SubscriptionPlanInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserSubscription {
    return new UserSubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserSubscription {
    return new UserSubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserSubscription {
    return new UserSubscription().fromJsonString(jsonString, options);
  }

  static equals(a: UserSubscription | PlainMessage<UserSubscription> | undefined, b: UserSubscription | PlainMessage<UserSubscription> | undefined): boolean {
    return proto3.util.equals(UserSubscription, a, b);
  }

  static _enums: {
    Status: typeof UserSubscription.Status,
    PlanContext: typeof UserSubscription.PlanContext,
  };
}

export namespace UserSubscription {
  /**
   * @generated from enum web.public.UserSubscription.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: ACTIVE = 1;
     */
    ACTIVE = 1,

    /**
     * @generated from enum value: EXPIRED = 2;
     */
    EXPIRED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UserSubscription.Status)
  proto3.util.setEnumType(UserSubscription.Status, "web.public.UserSubscription.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ACTIVE" },
    { no: 2, name: "EXPIRED" },
  ]);
}

export namespace UserSubscription {
  /**
   * Deprecated
   *
   * @generated from enum web.public.UserSubscription.PlanContext
   */
  export enum PlanContext {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    DEFAULT = 0,

    /**
     * @generated from enum value: CASH_ADVANCE = 1;
     */
    CASH_ADVANCE = 1,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UserSubscription.PlanContext)
  proto3.util.setEnumType(UserSubscription.PlanContext, "web.public.UserSubscription.PlanContext", [
    { no: 0, name: "DEFAULT" },
    { no: 1, name: "CASH_ADVANCE" },
  ]);
}

export namespace UserSubscription {
  /**
   * Deprecated
   *
   * @generated from message web.public.UserSubscription.Benefit
   */
  export class Benefit extends Message<UserSubscription.Benefit> {
    /**
     * @generated from field: string title = 1;
     */
    title = "";

    /**
     * @generated from field: string description = 2;
     */
    description = "";

    /**
     * @generated from field: string icon_url = 3;
     */
    iconUrl = "";

    /**
     * @generated from field: string cta_url = 5;
     */
    ctaUrl = "";

    /**
     * @generated from field: string cta_text = 6;
     */
    ctaText = "";

    constructor(data?: PartialMessage<UserSubscription.Benefit>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.UserSubscription.Benefit";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 5, name: "cta_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 6, name: "cta_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserSubscription.Benefit {
      return new UserSubscription.Benefit().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserSubscription.Benefit {
      return new UserSubscription.Benefit().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserSubscription.Benefit {
      return new UserSubscription.Benefit().fromJsonString(jsonString, options);
    }

    static equals(a: UserSubscription.Benefit | PlainMessage<UserSubscription.Benefit> | undefined, b: UserSubscription.Benefit | PlainMessage<UserSubscription.Benefit> | undefined): boolean {
      return proto3.util.equals(UserSubscription.Benefit, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.UserSubscriptionInvoice
 */
export class UserSubscriptionInvoice extends Message<UserSubscriptionInvoice> {
  /**
   * @generated from field: google.protobuf.Timestamp purchased_at = 1;
   */
  purchasedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp refunded_at = 2;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 3;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 4;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: int32 total_price_cents = 5;
   */
  totalPriceCents = 0;

  /**
   * @generated from field: string title = 6;
   */
  title = "";

  /**
   * @generated from field: web.public.UserSubscriptionInvoice.Status status = 7;
   */
  status = UserSubscriptionInvoice.Status.UNKNOWN;

  constructor(data?: PartialMessage<UserSubscriptionInvoice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UserSubscriptionInvoice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchased_at", kind: "message", T: Timestamp },
    { no: 2, name: "refunded_at", kind: "message", T: Timestamp },
    { no: 3, name: "start_at", kind: "message", T: Timestamp },
    { no: 4, name: "end_at", kind: "message", T: Timestamp },
    { no: 5, name: "total_price_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(UserSubscriptionInvoice.Status) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserSubscriptionInvoice {
    return new UserSubscriptionInvoice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserSubscriptionInvoice {
    return new UserSubscriptionInvoice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserSubscriptionInvoice {
    return new UserSubscriptionInvoice().fromJsonString(jsonString, options);
  }

  static equals(a: UserSubscriptionInvoice | PlainMessage<UserSubscriptionInvoice> | undefined, b: UserSubscriptionInvoice | PlainMessage<UserSubscriptionInvoice> | undefined): boolean {
    return proto3.util.equals(UserSubscriptionInvoice, a, b);
  }

  static _enums: {
    Status: typeof UserSubscriptionInvoice.Status,
  };
}

export namespace UserSubscriptionInvoice {
  /**
   * @generated from enum web.public.UserSubscriptionInvoice.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: INCOMPLETE = 1;
     */
    INCOMPLETE = 1,

    /**
     * @generated from enum value: PAID = 2;
     */
    PAID = 2,

    /**
     * @generated from enum value: REFUNDED = 3;
     */
    REFUNDED = 3,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UserSubscriptionInvoice.Status)
  proto3.util.setEnumType(UserSubscriptionInvoice.Status, "web.public.UserSubscriptionInvoice.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INCOMPLETE" },
    { no: 2, name: "PAID" },
    { no: 3, name: "REFUNDED" },
  ]);
}

/**
 * @generated from message web.public.UpdateAutoRenewalStatusResponse
 */
export class UpdateAutoRenewalStatusResponse extends Message<UpdateAutoRenewalStatusResponse> {
  /**
   * @generated from field: web.public.UpdateAutoRenewalStatusResponse.Status status = 1;
   */
  status = UpdateAutoRenewalStatusResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<UpdateAutoRenewalStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.UpdateAutoRenewalStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(UpdateAutoRenewalStatusResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAutoRenewalStatusResponse {
    return new UpdateAutoRenewalStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAutoRenewalStatusResponse {
    return new UpdateAutoRenewalStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAutoRenewalStatusResponse {
    return new UpdateAutoRenewalStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAutoRenewalStatusResponse | PlainMessage<UpdateAutoRenewalStatusResponse> | undefined, b: UpdateAutoRenewalStatusResponse | PlainMessage<UpdateAutoRenewalStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAutoRenewalStatusResponse, a, b);
  }

  static _enums: {
    Status: typeof UpdateAutoRenewalStatusResponse.Status,
  };
}

export namespace UpdateAutoRenewalStatusResponse {
  /**
   * @generated from enum web.public.UpdateAutoRenewalStatusResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(UpdateAutoRenewalStatusResponse.Status)
  proto3.util.setEnumType(UpdateAutoRenewalStatusResponse.Status, "web.public.UpdateAutoRenewalStatusResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.OpenSubscriptionAndCreditLineResponse
 */
export class OpenSubscriptionAndCreditLineResponse extends Message<OpenSubscriptionAndCreditLineResponse> {
  /**
   * @generated from field: web.public.OpenSubscriptionAndCreditLineResponse.Status status = 1;
   */
  status = OpenSubscriptionAndCreditLineResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  /**
   * @generated from field: web.public.CreditLineAccount credit_line = 4;
   */
  creditLine?: CreditLineAccount;

  constructor(data?: PartialMessage<OpenSubscriptionAndCreditLineResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.OpenSubscriptionAndCreditLineResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(OpenSubscriptionAndCreditLineResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
    { no: 4, name: "credit_line", kind: "message", T: CreditLineAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionAndCreditLineResponse {
    return new OpenSubscriptionAndCreditLineResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionAndCreditLineResponse {
    return new OpenSubscriptionAndCreditLineResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionAndCreditLineResponse {
    return new OpenSubscriptionAndCreditLineResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionAndCreditLineResponse | PlainMessage<OpenSubscriptionAndCreditLineResponse> | undefined, b: OpenSubscriptionAndCreditLineResponse | PlainMessage<OpenSubscriptionAndCreditLineResponse> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionAndCreditLineResponse, a, b);
  }

  static _enums: {
    Status: typeof OpenSubscriptionAndCreditLineResponse.Status,
  };
}

export namespace OpenSubscriptionAndCreditLineResponse {
  /**
   * @generated from enum web.public.OpenSubscriptionAndCreditLineResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OpenSubscriptionAndCreditLineResponse.Status)
  proto3.util.setEnumType(OpenSubscriptionAndCreditLineResponse.Status, "web.public.OpenSubscriptionAndCreditLineResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.ChangeUserSubscriptionRequest
 */
export class ChangeUserSubscriptionRequest extends Message<ChangeUserSubscriptionRequest> {
  /**
   * @generated from field: int32 current_subscription_plan_id = 1;
   */
  currentSubscriptionPlanId = 0;

  /**
   * @generated from field: int32 selected_subscription_plan_id = 2;
   */
  selectedSubscriptionPlanId = 0;

  /**
   * @generated from field: string cancellation_reason = 3;
   */
  cancellationReason = "";

  /**
   * @generated from field: string payment_method_token = 4;
   */
  paymentMethodToken = "";

  /**
   * @generated from field: web.public.AutoRenew auto_renew = 5;
   */
  autoRenew?: AutoRenew;

  constructor(data?: PartialMessage<ChangeUserSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ChangeUserSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "current_subscription_plan_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "selected_subscription_plan_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "payment_method_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "auto_renew", kind: "message", T: AutoRenew },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeUserSubscriptionRequest {
    return new ChangeUserSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionRequest {
    return new ChangeUserSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionRequest {
    return new ChangeUserSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeUserSubscriptionRequest | PlainMessage<ChangeUserSubscriptionRequest> | undefined, b: ChangeUserSubscriptionRequest | PlainMessage<ChangeUserSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(ChangeUserSubscriptionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ChangeUserSubscriptionResponse
 */
export class ChangeUserSubscriptionResponse extends Message<ChangeUserSubscriptionResponse> {
  /**
   * @generated from field: web.public.ChangeUserSubscriptionResponse.Status status = 1;
   */
  status = ChangeUserSubscriptionResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<ChangeUserSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ChangeUserSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ChangeUserSubscriptionResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeUserSubscriptionResponse {
    return new ChangeUserSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionResponse {
    return new ChangeUserSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionResponse {
    return new ChangeUserSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeUserSubscriptionResponse | PlainMessage<ChangeUserSubscriptionResponse> | undefined, b: ChangeUserSubscriptionResponse | PlainMessage<ChangeUserSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(ChangeUserSubscriptionResponse, a, b);
  }

  static _enums: {
    Status: typeof ChangeUserSubscriptionResponse.Status,
  };
}

export namespace ChangeUserSubscriptionResponse {
  /**
   * @generated from enum web.public.ChangeUserSubscriptionResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChangeUserSubscriptionResponse.Status)
  proto3.util.setEnumType(ChangeUserSubscriptionResponse.Status, "web.public.ChangeUserSubscriptionResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.CancelSubscriptionRequest
 */
export class CancelSubscriptionRequest extends Message<CancelSubscriptionRequest> {
  /**
   * @generated from field: string cancellation_reason = 1;
   */
  cancellationReason = "";

  /**
   * deprecated
   *
   * @generated from field: web.public.UserSubscription.PlanContext plan_context = 2;
   */
  planContext = UserSubscription.PlanContext.DEFAULT;

  /**
   * @generated from field: bool issue_refund = 3;
   */
  issueRefund = false;

  constructor(data?: PartialMessage<CancelSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CancelSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_context", kind: "enum", T: proto3.getEnumType(UserSubscription.PlanContext) },
    { no: 3, name: "issue_refund", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelSubscriptionRequest {
    return new CancelSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelSubscriptionRequest | PlainMessage<CancelSubscriptionRequest> | undefined, b: CancelSubscriptionRequest | PlainMessage<CancelSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(CancelSubscriptionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.CancelSubscriptionResponse
 */
export class CancelSubscriptionResponse extends Message<CancelSubscriptionResponse> {
  /**
   * @generated from field: web.public.CancelSubscriptionResponse.Status status = 1;
   */
  status = CancelSubscriptionResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  /**
   * @generated from field: bool will_refund = 4;
   */
  willRefund = false;

  constructor(data?: PartialMessage<CancelSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.CancelSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(CancelSubscriptionResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
    { no: 4, name: "will_refund", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelSubscriptionResponse {
    return new CancelSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelSubscriptionResponse | PlainMessage<CancelSubscriptionResponse> | undefined, b: CancelSubscriptionResponse | PlainMessage<CancelSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(CancelSubscriptionResponse, a, b);
  }

  static _enums: {
    Status: typeof CancelSubscriptionResponse.Status,
  };
}

export namespace CancelSubscriptionResponse {
  /**
   * @generated from enum web.public.CancelSubscriptionResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CancelSubscriptionResponse.Status)
  proto3.util.setEnumType(CancelSubscriptionResponse.Status, "web.public.CancelSubscriptionResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.RenewSubscriptionAndCreditLineResponse
 */
export class RenewSubscriptionAndCreditLineResponse extends Message<RenewSubscriptionAndCreditLineResponse> {
  /**
   * @generated from field: web.public.RenewSubscriptionAndCreditLineResponse.Status status = 1;
   */
  status = RenewSubscriptionAndCreditLineResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  /**
   * @generated from field: web.public.CreditLineAccount credit_line = 4;
   */
  creditLine?: CreditLineAccount;

  constructor(data?: PartialMessage<RenewSubscriptionAndCreditLineResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.RenewSubscriptionAndCreditLineResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(RenewSubscriptionAndCreditLineResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
    { no: 4, name: "credit_line", kind: "message", T: CreditLineAccount },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RenewSubscriptionAndCreditLineResponse {
    return new RenewSubscriptionAndCreditLineResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RenewSubscriptionAndCreditLineResponse {
    return new RenewSubscriptionAndCreditLineResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RenewSubscriptionAndCreditLineResponse {
    return new RenewSubscriptionAndCreditLineResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RenewSubscriptionAndCreditLineResponse | PlainMessage<RenewSubscriptionAndCreditLineResponse> | undefined, b: RenewSubscriptionAndCreditLineResponse | PlainMessage<RenewSubscriptionAndCreditLineResponse> | undefined): boolean {
    return proto3.util.equals(RenewSubscriptionAndCreditLineResponse, a, b);
  }

  static _enums: {
    Status: typeof RenewSubscriptionAndCreditLineResponse.Status,
  };
}

export namespace RenewSubscriptionAndCreditLineResponse {
  /**
   * @generated from enum web.public.RenewSubscriptionAndCreditLineResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(RenewSubscriptionAndCreditLineResponse.Status)
  proto3.util.setEnumType(RenewSubscriptionAndCreditLineResponse.Status, "web.public.RenewSubscriptionAndCreditLineResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.GetUserSubscriptionRequest
 */
export class GetUserSubscriptionRequest extends Message<GetUserSubscriptionRequest> {
  /**
   * deprecated
   *
   * @generated from field: web.public.UserSubscription.PlanContext plan_context = 1;
   */
  planContext = UserSubscription.PlanContext.DEFAULT;

  constructor(data?: PartialMessage<GetUserSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetUserSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_context", kind: "enum", T: proto3.getEnumType(UserSubscription.PlanContext) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserSubscriptionRequest {
    return new GetUserSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserSubscriptionRequest {
    return new GetUserSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserSubscriptionRequest {
    return new GetUserSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserSubscriptionRequest | PlainMessage<GetUserSubscriptionRequest> | undefined, b: GetUserSubscriptionRequest | PlainMessage<GetUserSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(GetUserSubscriptionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.GetUserSubscriptionResponse
 */
export class GetUserSubscriptionResponse extends Message<GetUserSubscriptionResponse> {
  /**
   * @generated from field: web.public.GetUserSubscriptionResponse.Status status = 1;
   */
  status = GetUserSubscriptionResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: web.public.UserSubscription user_subscription = 3;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<GetUserSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.GetUserSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(GetUserSubscriptionResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserSubscriptionResponse {
    return new GetUserSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserSubscriptionResponse {
    return new GetUserSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserSubscriptionResponse {
    return new GetUserSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserSubscriptionResponse | PlainMessage<GetUserSubscriptionResponse> | undefined, b: GetUserSubscriptionResponse | PlainMessage<GetUserSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(GetUserSubscriptionResponse, a, b);
  }

  static _enums: {
    Status: typeof GetUserSubscriptionResponse.Status,
  };
}

export namespace GetUserSubscriptionResponse {
  /**
   * @generated from enum web.public.GetUserSubscriptionResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(GetUserSubscriptionResponse.Status)
  proto3.util.setEnumType(GetUserSubscriptionResponse.Status, "web.public.GetUserSubscriptionResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

/**
 * @generated from message web.public.SubscriptionPlanInfo
 */
export class SubscriptionPlanInfo extends Message<SubscriptionPlanInfo> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: int32 price_cents = 3;
   */
  priceCents = 0;

  /**
   * @generated from field: int32 duration_months = 4;
   */
  durationMonths = 0;

  /**
   * deprecated
   *
   * @generated from field: repeated web.public.SubscriptionPlanInfo.SubscriptionPlanBenefit benefits = 5;
   */
  benefits: SubscriptionPlanInfo.SubscriptionPlanBenefit[] = [];

  /**
   * @generated from field: web.public.SubscriptionPlan subscription_plan = 6;
   */
  subscriptionPlan = SubscriptionPlan.BASIC;

  /**
   * @generated from field: bool no_credit_line = 7;
   */
  noCreditLine = false;

  constructor(data?: PartialMessage<SubscriptionPlanInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.SubscriptionPlanInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "duration_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "benefits", kind: "message", T: SubscriptionPlanInfo.SubscriptionPlanBenefit, repeated: true },
    { no: 6, name: "subscription_plan", kind: "enum", T: proto3.getEnumType(SubscriptionPlan) },
    { no: 7, name: "no_credit_line", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionPlanInfo {
    return new SubscriptionPlanInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionPlanInfo {
    return new SubscriptionPlanInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionPlanInfo {
    return new SubscriptionPlanInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionPlanInfo | PlainMessage<SubscriptionPlanInfo> | undefined, b: SubscriptionPlanInfo | PlainMessage<SubscriptionPlanInfo> | undefined): boolean {
    return proto3.util.equals(SubscriptionPlanInfo, a, b);
  }

  static _enums: {
  };
}

export namespace SubscriptionPlanInfo {
  /**
   * Deprecated
   *
   * @generated from message web.public.SubscriptionPlanInfo.SubscriptionPlanBenefit
   */
  export class SubscriptionPlanBenefit extends Message<SubscriptionPlanInfo.SubscriptionPlanBenefit> {
    /**
     * @generated from field: string title = 1;
     */
    title = "";

    /**
     * @generated from field: string description = 2;
     */
    description = "";

    /**
     * @generated from field: string icon_url = 3;
     */
    iconUrl = "";

    constructor(data?: PartialMessage<SubscriptionPlanInfo.SubscriptionPlanBenefit>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.SubscriptionPlanInfo.SubscriptionPlanBenefit";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionPlanInfo.SubscriptionPlanBenefit {
      return new SubscriptionPlanInfo.SubscriptionPlanBenefit().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionPlanInfo.SubscriptionPlanBenefit {
      return new SubscriptionPlanInfo.SubscriptionPlanBenefit().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionPlanInfo.SubscriptionPlanBenefit {
      return new SubscriptionPlanInfo.SubscriptionPlanBenefit().fromJsonString(jsonString, options);
    }

    static equals(a: SubscriptionPlanInfo.SubscriptionPlanBenefit | PlainMessage<SubscriptionPlanInfo.SubscriptionPlanBenefit> | undefined, b: SubscriptionPlanInfo.SubscriptionPlanBenefit | PlainMessage<SubscriptionPlanInfo.SubscriptionPlanBenefit> | undefined): boolean {
      return proto3.util.equals(SubscriptionPlanInfo.SubscriptionPlanBenefit, a, b);
    }

    static _enums: {
    };
  }
}

/**
 * @generated from message web.public.ListSubscriptionPlansRequest
 */
export class ListSubscriptionPlansRequest extends Message<ListSubscriptionPlansRequest> {
  /**
   * deprecated
   *
   * @generated from field: web.public.UserSubscription.PlanContext plan_context = 1;
   */
  planContext = UserSubscription.PlanContext.DEFAULT;

  constructor(data?: PartialMessage<ListSubscriptionPlansRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListSubscriptionPlansRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_context", kind: "enum", T: proto3.getEnumType(UserSubscription.PlanContext) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionPlansRequest {
    return new ListSubscriptionPlansRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionPlansRequest {
    return new ListSubscriptionPlansRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionPlansRequest {
    return new ListSubscriptionPlansRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionPlansRequest | PlainMessage<ListSubscriptionPlansRequest> | undefined, b: ListSubscriptionPlansRequest | PlainMessage<ListSubscriptionPlansRequest> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionPlansRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message web.public.ListSubscriptionPlansResponse
 */
export class ListSubscriptionPlansResponse extends Message<ListSubscriptionPlansResponse> {
  /**
   * @generated from field: web.public.ListSubscriptionPlansResponse.Status status = 1;
   */
  status = ListSubscriptionPlansResponse.Status.UNKNOWN;

  /**
   * @generated from field: web.public.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated web.public.SubscriptionPlanInfo subscription_plans = 3;
   */
  subscriptionPlans: SubscriptionPlanInfo[] = [];

  constructor(data?: PartialMessage<ListSubscriptionPlansResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.ListSubscriptionPlansResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ListSubscriptionPlansResponse.Status) },
    { no: 2, name: "error", kind: "message", T: Error },
    { no: 3, name: "subscription_plans", kind: "message", T: SubscriptionPlanInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionPlansResponse | PlainMessage<ListSubscriptionPlansResponse> | undefined, b: ListSubscriptionPlansResponse | PlainMessage<ListSubscriptionPlansResponse> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionPlansResponse, a, b);
  }

  static _enums: {
    Status: typeof ListSubscriptionPlansResponse.Status,
  };
}

export namespace ListSubscriptionPlansResponse {
  /**
   * @generated from enum web.public.ListSubscriptionPlansResponse.Status
   */
  export enum Status {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: SUCCESS = 1;
     */
    SUCCESS = 1,

    /**
     * @generated from enum value: FAILED = 2;
     */
    FAILED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ListSubscriptionPlansResponse.Status)
  proto3.util.setEnumType(ListSubscriptionPlansResponse.Status, "web.public.ListSubscriptionPlansResponse.Status", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "SUCCESS" },
    { no: 2, name: "FAILED" },
  ]);
}

